import { api } from "../http";
import { ApiResponse } from "../types";

export const getUnAllotedSeat = async (): Promise<ApiResponse<SeatModel[]>> => {
  try {
    const response = await api.get<ApiResponse<SeatModel[]>>(
      "/Seat/GetUnAllotedSeats"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};
